// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SSOSuccessVideoModalComponent } from 'src/app/modals/sso-success-video-modal/sso-success-video-modal.component';
import { getShortenedVideoDesc } from 'src/app/utils/utils';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'custom-deal-types-help-panel',
    templateUrl: './custom-deal-types-help-panel.component.html',
    styleUrls: ['./custom-deal-types-help-panel.component.scss'],
})
export class CustomDealTypesHelpPanelComponent implements OnInit {
    envVideoUrl: string = environment.videoSrcUrl;
    isReadMore = false;
    fullDesc =
        ' Before creating a custom deal type, make sure you have set up the required forms and documents in the F&I Forms library. To add a custom deal type, click the Create Custom Deal Type button and give the deal type a name. Use a unique and descriptive name so you can easily find it when you are creating a Deal Jacket. Then select all the F&I Forms you want to include in the deal type by checking the boxes next to each form name. To modify an existing custom deal type, select it from the list and then make the necessary changes. You can also delete custom deal types no longer in use. Watch the video for a step-by-step demonstration of these processes.';
    shortDesc = '';
    constructor(private readonly dialog: MatDialog) {}
    ngOnInit(): void {
        this.shortDesc = getShortenedVideoDesc(this.fullDesc);
    }

    readMore() {
        this.isReadMore = !this.isReadMore;
    }

    openVideo(title: string, source: string): void {
        this.dialog.open(SSOSuccessVideoModalComponent, {
            width: '700px',
            closeOnNavigation: false,
            data: {
                videoTitle: title,
                videoSource: this.envVideoUrl + source,
            },
        });
    }
}
